import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TRANSLOCO_SCOPE } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { BehaviorSubject, filter, Subject, takeUntil } from 'rxjs';
import { CommonUtilsService } from '../../services/commonutils/common-utils.service';
import { getInstanceEventTypes$ } from '../../store/selectors/custom.selector';
import { UtilsService } from '../../services/utils/utils.service';

import { GetInstanceEventTypes } from '../../store/actions';

@Component({
    selector: 'app-notifications-dialog',
    templateUrl: './notifications-dialog.component.html',
    styleUrls: ['./notifications-dialog.component.scss'],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: '',
        },
    ],
    standalone: false,
})
export class NotificationsDialogComponent implements OnDestroy, OnInit {
    @Input() public instanceId: string;

    private unSubscribe = new Subject<void>();
    public notificationsState: BehaviorSubject<{
        eventTypesList: { id: string; displayName: string }[];
    }> = new BehaviorSubject(undefined);

    constructor(private store$: Store, private dialogRef: MatDialogRef<NotificationsDialogComponent>, protected _libUtils: UtilsService) {}

    private getEventTypes = () => {
        this.store$.dispatch(GetInstanceEventTypes());
    };

    closeModal = () => {
        this.dialogRef.close();
    };

    private generateEvents = (eventTypes: any[]) => {
        this.notificationsState.next({ eventTypesList: eventTypes });
    };

    ngOnInit(): void {
        this.store$
            .select(getInstanceEventTypes$)
            .pipe(
                takeUntil(this.unSubscribe),
                filter(eventTypes => eventTypes !== undefined)
            )
            .subscribe(eventTypes => {
                const eventTypesList = CommonUtilsService.cloneObject(eventTypes['ASSET'] || []);
                this.generateEvents(eventTypesList);
            });

        this.getEventTypes();
    }

    ngOnDestroy(): void {
        this.unSubscribe.next();
        this.unSubscribe.complete();
    }
}
